import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import config from '../functions/config';


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faUsers,
  faRightFromBracket,
  faBook,
  faListCheck,
  faCartShopping,
  faBagShopping,
} from "@fortawesome/free-solid-svg-icons";

const RentalHistory = () => {
  const [rentals, setRentals] = useState([]);
  const [message, setMessage] = useState("");
  const [selectedRental, setSelectedRental] = useState(null);
  const [extraFine, setExtraFine] = useState("");
  

  // Fetch rental history from the API
  useEffect(() => {
    fetchRentalHistory();
  }, []);

  const fetchRentalHistory = async () => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/rental-history/`);
      const data = await response.json();
      const sortedRentals = sortRentalsByStatusAndDate(data); // Sort rentals
      setRentals(sortedRentals);
    } catch (error) {
      console.error("Error fetching rental history:", error);
    }
  };

  // Sort rental items by status and due date
  const sortRentalsByStatusAndDate = (rentals) => {
    return rentals.sort((a, b) => {
      // Define a custom order for statuses
      const statusOrder = {
        "Overdue": 1,
        "Pending": 2,
        "Fined": 4,
        "paid": 3,

        "Completed": 5,

      };

      // First, compare by status order
      if (statusOrder[a.status] !== statusOrder[b.status]) {
        return statusOrder[a.status] - statusOrder[b.status];
      }

      // If statuses are the same, compare by due date for overdue items
      if (a.status === "Pending" || a.status === "Overdue") {
        return new Date(a.due_date) - new Date(b.due_date); // Compare due date (earliest first)
      }

      return 0; // If status and due date are the same, keep the order as is
    });
  };

  // Handle Fine Action
  const openFineModal = (rental) => {
    setSelectedRental(rental);
    setExtraFine(""); // Reset extra fine input

    const fineModal = document.getElementById('fineModal');
    fineModal.classList.add('show');
    fineModal.style.display = 'block';
    fineModal.setAttribute('aria-hidden', 'false');
  };

  const handleFineSubmit = async () => {
    if (!selectedRental) return;

    const updatedFine = parseFloat(selectedRental.fine) + parseFloat(extraFine || 0);

    try {
      const response = await fetch(`${config.BASE_URL}/api/apply-fine/${selectedRental.id}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ fine: updatedFine }),
      });

      if (response.ok) {
        setMessage("Fine updated successfully.");
        window.location.reload();

        fetchRentalHistory(); // Refresh data
        setSelectedRental(null); // Reset selection
      } else {
        const result = await response.json();
        setMessage(result.error || "Failed to update fine.");
      }
    } catch (error) {
      console.error("Error updating fine:", error);
      setMessage("Error updating fine.");
    }

    // Hide modal
    const fineModal = document.getElementById('fineModal');
    fineModal.classList.remove('show');
    fineModal.style.display = 'none';
    fineModal.setAttribute('aria-hidden', 'true');
  };

  const handleComplete = async (rentalId) => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/mark-completed/${rentalId}/`, {
        method: 'POST',
      });

      if (response.ok) {
        setMessage("Rental marked as completed.");
        fetchRentalHistory(); // Refresh data
      } else {
        const result = await response.json();
        setMessage(result.error || "Failed to mark rental as completed.");
      }
    } catch (error) {
      console.error("Error completing rental:", error);
      setMessage("Error completing rental.");
    }
  };

  return (

<div>

{/* Navbar */}
<nav className="navbar navbar-expand-lg navbar-light fixed-top">
<a className="navbar-brand text-light" href="#">
Admin 
</a>
<button
className="navbar-toggler bg-light"
type="button"
data-bs-toggle="collapse"
data-bs-target="#navbarSupportedContent"
aria-controls="navbarSupportedContent"
aria-expanded="false"
aria-label="Toggle navigation"
>
<span className="navbar-toggler-icon"></span>
</button>
<div className="collapse navbar-collapse" id="navbarSupportedContent">
<ul className="navbar-nav mr-auto flex-column vertical-nav px-3">
<li className="nav-item">
  <a className="nav-link text-light" href="/admin">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faTachometerAlt} />
    </span>
    <span className="nav-text">Dashboard</span>
  </a>
</li>
<li className="nav-item">
  <a className="nav-link text-light" href="/register-book">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faBook} />
    </span>
    <span className="nav-text">Register Book</span>
  </a>
</li>
<li className="nav-item">
  <a className="nav-link text-light" href="/list-users">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faUsers} />
    </span>
    <span className="nav-text">Manage User</span>
  </a>
</li>
<li className="nav-item">
  <a className="nav-link text-light" href="/view-books">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faListCheck} />
    </span>
    <span className="nav-text">Manage Book</span>
  </a>
</li>
<li className="nav-item">
<a className="nav-link text-light" href="/adminpurchase">
<span className="nav-icon">
      <FontAwesomeIcon icon={faCartShopping} />
    </span>
    <span className="nav-text">Purchase History</span>
  </a>
</li>
<li className="nav-item">
  <a className="nav-link text-light" href="/adminrent">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faBagShopping} />
    </span>
    <span className="nav-text text-warning">Rental History</span>
  </a>
</li>
</ul>
<ul className="navbar-nav ml-auto pr-5">
<li className="nav-item mr-5">
  <a className="nav-link text-light fixed-right" href="/login">
    <FontAwesomeIcon icon={faRightFromBracket} /> Logout
  </a>
</li>
</ul>
</div>
</nav>


<div className="container content px-5 mt-5 pt-4">
  <h1 className="text-center " >Rental History</h1>

  {message && <div className="alert alert-info">{message}</div>}

  <div className="table-responsive shadow-sm rounded">
    <table className="table table-striped table-bordered table-hover align-middle">
      <thead className="table-dark">
        <tr>
          <th>#</th>
          <th>Book Name</th>
          <th>User</th>
          <th>Quantity</th>
          <th>Rental Start Date</th>
          <th>Due Date</th>
          <th>Fine</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {rentals.length > 0 ? (
          rentals.map((rental, index) => (
            <tr key={rental.id} className={`table-row ${new Date(rental.due_date) < new Date() && rental.status === 'Pending' ? 'table-danger' : ''}`}>
              <td>{index + 1}</td>
              <td>{rental.book_name}</td>
              <td>{rental.user_name}</td>
              <td>{rental.quantity}</td>
              <td>{rental.start_date}</td>
              <td>{rental.due_date}</td>
              <td>{rental.fine}</td>
              <td>
                {rental.status}
                {new Date(rental.due_date) < new Date() && rental.status === 'Pending' && ' (Overdue)'}
              </td>
              <td>
                {/* Actions based on rental status */}
                {rental.status === 'Pending' && new Date(rental.due_date) < new Date() && (
                  <button
                    className="btn btn-danger btn-sm me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#fineModal"
                    onClick={() => setSelectedRental(rental)}
                  >
                    Fine
                  </button>
                )}

                {rental.status === 'Fined' && new Date(rental.due_date) < new Date() && (
                  <button
                    className="btn btn-danger btn-sm me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#fineModal"
                    onClick={() => setSelectedRental(rental)}
                  >
                    Renew Fine
                  </button>
                )}

                {rental.status === 'paid' && new Date(rental.due_date) > new Date() && (
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => handleComplete(rental.id)}
                  >
                    Mark Completed
                  </button>
                )}

                {rental.status !== 'Completed' && rental.status !== 'Pending' && rental.status !== 'Fined' && (
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => handleComplete(rental.id)}
                  >
                    Mark Completed
                  </button>
                )}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="9" className="text-center text-muted">
              No rental history found.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>

  {/* Fine Modal */}
  <div
    id="fineModal"
    className="modal fade"
    tabIndex="-1"
    role="dialog"
    aria-labelledby="fineModalLabel"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header bg-primary text-light">
          <h5 className="modal-title" id="fineModalLabel">Apply Fine</h5>
          <button
            type="button"
            className="btn-close btn-close-white"
            aria-label="Close"
            data-bs-dismiss="modal"
            aria-hidden="true"
          ></button>
        </div>
        <div className="modal-body">
          {selectedRental ? (
            <div>
              <p>
                <strong>Due Amount:</strong> ${selectedRental.total_price || 0}
              </p>
              <div className="form-group">
                <label htmlFor="extraFine" className="form-label">Extra Fine:</label>
                <input
                  type="number"
                  id="extraFine"
                  className="form-control"
                  value={extraFine}
                  onChange={(e) => setExtraFine(e.target.value)}
                  min="0"
                  step="0.01"
                />
              </div>
            </div>
          ) : (
            <p>No rental selected.</p>
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleFineSubmit}
          >
            Submit Fine
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


    <style jsx>{`
 
  
 .content {
   margin-left: 200px;
 }
 @media (max-width: 768px) {
   .vertical-nav {
     width: 100%;
   }
   .content {
     margin-left: 0;
   }
 }
.navbar {
background: #1a1a1a; /* Dark background color */
}

.vertical-nav {
background: #1a1a1a; /* Dark background color */
position: fixed;
top: 56px;
left: 0;
height: calc(100% - 56px);
overflow-y: auto;
padding-top: 30px;
z-index: 999;
}

.vertical-nav .nav-link {
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
padding: 10px 15px;
color: #ff6700; /* Dark orange font color */
transition: background-color 0.3s; /* Smooth hover effect */
}

.vertical-nav .nav-link:hover {
background-color: #2a2a2a; /* Slightly lighter background for hover effect */
}

.nav-icon {
font-size: 20px;
margin-right: 10px;
color: #ff6700; /* Dark orange for icons */
}

li {
border-bottom: 2px solid black;
}

li:hover {
background-color: #2a2a2a; /* Slightly lighter background for hover effect */
}


.btn {
width: 100%; /* Full-width button */
color: white;
border: none;
padding: 10px;
font-size: 16px;
font-weight: bold;
border-radius: 5px;
}

.btn-danger:hover {
background-color: red; /* Darker orange on hover */
cursor: pointer;
}

.btn-success:hover {
background-color: green; /* Darker orange on hover */
cursor: pointer;
}

body {
position: relative;
margin: 0; /* Remove default margins */
padding: 0; /* Remove default padding */
}

body::before {
content: '';
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background: url('https://wallpaperaccess.com/full/934072.jpg') no-repeat center center fixed;
background-size: cover; /* Ensure the image covers the entire body */
opacity: 0.4; /* Apply opacity only to the image */
z-index: -1; /* Place it behind all other content */
}

a {
text-decoration: none;
}

h1, h2, h3, h4, h5, h6 {
font-family: "Times New Roman", Times, serif; /* Classic font */
color: #1a1a1a; /* Match the theme color */
}
`}</style>

    </div>
  );
};

export default RentalHistory;
